<div class="grid-1" [formGroup]="this.form">
  @if (this.subscriptionCount > 1) {
    <app-subscription-selector
      (selectedSubscriptionChanged)="this.setCurrentSubscription($event);"/>
  }
  <div
    class="chat-input"
    [class.multiple-subscriptions]="this.subscriptionCount > 1"
    >
    <app-countable-textarea formControlName="textarea" [minCharacters]="config.support.textMinCharacterCount">
      <app-button
        button
        class="hide-mobile"
        (click)="this.submit()"
        [disabled]="this.form.invalid"
        onkeydown=""
        >Verzenden
      </app-button>
    </app-countable-textarea>
  </div>
  <app-button
    class="show-mobile"
    (click)="this.submit()"
    [disabled]="this.form.invalid"
    onkeydown=""
    >Verzenden
  </app-button>
</div>
